module.exports = __webpack_public_path__ + "static/media/324240650359211.10aec581.webp";